/*
  Project: Growth Point
  Author: xfive
 */

import 'lity';
import './vendor/lazyload';
import './modules/focus-outline';
import './modules/main-nav';
import MatchmakerSlider from './modules/matchmaker-slider';
import './modules/logo-shape-bg';
import './modules/aos';
import './modules/aria';
import './modules/lity';
import './modules/c-carousel';
import './modules/slider';
import './modules/growthpoints';
import './modules/insights';
// import './modules/latest-news';
import './modules/boxes';
import './modules/partners';
import './modules/do-scroll';
import './modules/google-maps';
import './modules/sumoselect';
import './modules/hsc-partners-carousel';
import './modules/comments';
import './modules/addthis';
import './modules/values';
import './modules/accordion';
import './modules/growth';

MatchmakerSlider.init();



// WEBPACK FOOTER //
// ./src/scripts/app.js